import { AddTag, TagLabel } from "@/types/common";
import request from ".";

const TAG_URL = '/wms/tag';

const APIS = {
  addTag: TAG_URL + '/add',
  tagDels: TAG_URL + '/dels',
}

export const addTag = (data: AddTag) => {
  return new Promise<TagLabel>((resolve, reject) => {
    request<TagLabel, AddTag>(APIS.addTag, { params: { body: data } })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
};
export const tagDels = (ids: string[]) => {
  return new Promise<void>((resolve, reject) => {
    request<void, string[]>(APIS.tagDels, { params: { body: ids } })
      .then(() => resolve())
      .catch((err) => reject(err));
  })
};